import { mockInstance, withDelay } from '../../../../api/axiosInstance.mock';

import { RESET_OFFRE_CHOISIE_END_POINT } from '../../apiEndPoints';
import { dataCoEmprunteur1 as sessionMockData } from '../../contexte/useSessionApi/useSessionApi.mock';

const endPoint = RESET_OFFRE_CHOISIE_END_POINT.replace(
    /{idDemande}/g,
    String(sessionMockData?.contextePret?.idDemande)
);

export const useResetOffreChoisieApiMock = (): any => {
    mockInstance.onPut(endPoint).reply(
        withDelay(
            [
                200,
                {
                    pageInitiale: 'OFFRE',
                    codeAvis: null
                }
            ],
            200
        )
    );
};
